import {createApp} from 'vue'
import ReportCard from './ReportCard'

const el = '.kb-component--report-card'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM && DOM.length){
        DOM.forEach((ReportCardDom)=>{
            const data = ReportCardDom.dataset.data 
                ? JSON.parse(ReportCardDom.dataset.data)
                : null;

            const component = createApp(ReportCard,{data}).use(Store)
            component.mount(ReportCardDom)
        })
    }
}